import './GenericDialog.css'
import cx from 'classnames'
import React from 'react'
import { Dialog } from '../Dialog/Dialog'

// Dialog size classes - shared with FullscreenDialog
export const dialogSizeClasses = {
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  '5xl': 'max-w-5xl'
}

function GenericDialogHeader({
  title,
  subtitle,
  variant,
  icon
}: {
  title: string
  subtitle?: string
  variant?: 'default' | 'warning'
  icon?: React.ReactNode
}) {
  if (variant === 'default') {
    return (
      <header className="generic-dialog-header-default">
        <div className="generic-dialog-header-flex">
          {icon && <div className="generic-dialog-header-icon">{icon}</div>}
          <div>
            <h2 className="generic-dialog-title">{title}</h2>
            {subtitle && <p className="generic-dialog-subtitle">{subtitle}</p>}
          </div>
        </div>
      </header>
    )
  }
  if (variant === 'warning') {
    return (
      <header className="generic-dialog-header-warning">
        {icon && <div className="generic-dialog-header-icon">{icon}</div>}
        <div>
          <h2 className="generic-dialog-title">{title}</h2>
          {subtitle && <p className="generic-dialog-subtitle-warning">{subtitle}</p>}
        </div>
      </header>
    )
  }
}

export function GenericDialog({
  isOpen,
  close,
  children,
  size,
  onAfterLeave,
  title,
  subtitle,
  variant = 'default',
  icon,
  preventCloseOnOutsideClick = false
}: {
  isOpen: boolean
  close: () => void
  children: React.ReactNode
  size?: 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl'
  variant?: 'default' | 'warning'
  onAfterLeave?: () => void
  title?: string
  subtitle?: string
  icon?: React.ReactNode
  preventCloseOnOutsideClick?: boolean
}) {
  return (
    <Dialog
      isOpen={isOpen}
      close={close}
      onAfterLeave={onAfterLeave}
      preventCloseOnOutsideClick={preventCloseOnOutsideClick}
    >
      <div className={cx('generic-dialog-container', size ? dialogSizeClasses[size] : '')}>
        <div className="group">
          {title && (
            <GenericDialogHeader variant={variant} title={title} subtitle={subtitle} icon={icon} />
          )}
          <div className={cx('generic-dialog-body', { 'generic-dialog-body-no-header': !!title })}>
            {children}
          </div>
        </div>
      </div>
    </Dialog>
  )
}
